function updateCartCounter(selector, itemQty, eventName){
  const containerCartCount = document.querySelector(selector)
  if (!!containerCartCount){
    if(eventName == 'change'){
      containerCartCount.innerHTML = itemQty;
    } else if(eventName == 'add'){
      containerCartCount.innerHTML = parseInt(containerCartCount.innerHTML) + itemQty;
    }
  }
};

document.addEventListener('ajaxProduct:added', function(evt) {
  const qtyValue =  parseInt(document.querySelector('[aria-label="quantity"]').value)
  updateCartCounter('.eg-article-count', qtyValue, 'add')
});

document.addEventListener('cart:updated', function(evt) {
  //Update counter in cart drawer
  updateCartCounter('.eg-article-count', evt.detail.cart.item_count, 'change')
  //Update counter on cart page
  updateCartCounter('.cart-item-count', evt.detail.cart.item_count, 'change')
});
